import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  root: {},
  tableHead: {
    width: '100%',
    display: 'grid',
    gridTemplateColumns: '8fr 6fr 4fr 6fr 6fr 6fr 6fr 2fr',
    color: theme.palette.text.secondary,
    alignItems: 'center',
    padding: '0 0 0 12px',
    marginBottom: 4,
    marginTop: 4,
    backgroundColor: theme.palette.background.paper,
    borderRadius: 12
  },
  tableHeadAdmin: {
    gridTemplateColumns: '8fr 6fr 4fr 6fr 6fr 6fr 6fr 3fr 3fr 2fr'
  },
  tableHeadMobile: {
    width: '100%',
    display: 'grid',
    gridTemplateColumns: '3fr 1fr',
    color: theme.palette.text.secondary,
    padding: '8px 0 8px 0',
    marginBottom: 4,
    marginTop: 4,
    backgroundColor: theme.palette.background.paper,
    borderRadius: 12,
    alignItems: 'center'
  },
  tableHeadCellMobile: {
    textAlign: 'left',
    paddingLeft: 12
  },
  tableRowRoot: {
    display: 'grid',
    gridTemplateColumns: '42fr 2fr',
    height: 100,
    marginBottom: 4,
    alignItems: 'center',
    backgroundColor: theme.palette.background.default,
    borderRadius: 20,
    cursor: 'pointer',
    paddingLeft: 12,
    transition: 'background-color 0.3s ease-in-out',
    width: '100%',
    textAlign: 'unset',
    '&:hover': {
      backgroundColor: theme.palette.background.paper
    }
  },
  tableRowRootAdmin: {
    gridTemplateColumns: '48fr 2fr'
  },
  tableRow: {
    display: 'grid',
    gridTemplateColumns: '8fr 6fr 4fr 6fr 6fr 6fr 6fr',
    height: 100,
    alignItems: 'center',
    borderRadius: 20,
    cursor: 'pointer'
  },
  tableRowAdmin: {
    gridTemplateColumns: '8fr 6fr 4fr 6fr 6fr 6fr 6fr 3fr 3fr'
  },
  tableRowSkeleton: {
    gridTemplateColumns: '8fr 6fr 4fr 6fr 6fr 6fr 6fr 2fr',
    height: 103.2
  },
  tableRowSkeletonAdmin: {
    gridTemplateColumns: '8fr 6fr 4fr 6fr 6fr 6fr 6fr 3fr 3fr 2fr'
  },
  tableRowMobile: {
    cursor: 'pointer',
    display: 'grid',
    gridTemplateColumns: '3fr 1fr',
    height: 100,
    alignItems: 'center',
    backgroundColor: theme.palette.background.default,
    transition: 'background-color 0.3s ease-in-out',
    borderRadius: 20,
    paddingLeft: 12,
    '&:hover': {
      backgroundColor: theme.palette.background.paper
    }
  },
  userLogo: {
    width: 60,
    height: 60,
    borderRadius: '50%',
    background: '#dfdfdf',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginRight: 12
  },
  nameCell: {
    display: 'flex'
  },
  moreIcon: {
    cursor: 'pointer'
  },
  refreshButtonContainer: {
    margin: 'auto'
  },
  skeleton: {
    width: '50%'
  },
  userInfoContainerSkeleton: {
    width: '80%'
  },
  userInfoNameSkeleton: {
    width: '80%'
  }
}))

export default useStyles
